import { Link as StyledLink } from "rebass";
import { Helmet } from "react-helmet";

import { HeadingTitle } from "~/containers/HeadingTitle";
import { LayoutDirection } from "~/containers/Layout";
import { Link } from "~/components/Link";
import { ListeBlancheDpfiCreate } from "~/containers/ListeBlanche";
import { BoxWrapper } from "~/components/Grid";
import { SkipToContent } from "~/components";

function ListBlanchePage() {
  return (
    <>
      <Helmet>
        <title>Ajout d'un DPF individuel à la liste blanche | e-MJPM</title>
      </Helmet>
      <SkipToContent skipTo="liste_blanche_individuel_create" />
      <LayoutDirection>
        <BoxWrapper mt={3} px={1}>
          <Link
            to="/direction"
            component={(props) => (
              <StyledLink
                onClick={() => props.navigate(props.href)}
                mb={4}
                display="block"
              >
                &larr; Retour
              </StyledLink>
            )}
          />
          <HeadingTitle mb={4}>
            {"Ajout d'un DPF individuel à la liste blanche"}
          </HeadingTitle>
          <ListeBlancheDpfiCreate />
        </BoxWrapper>
      </LayoutDirection>
    </>
  );
}

export default ListBlanchePage;
